import { CalendarDays, Handshake, Search, Trophy, type LucideIcon } from 'lucide-react';
export interface SportOption {
  id: string;
  label: string;
  dotClassName: string;
}

export const SPORT_OPTIONS: SportOption[] = [
  { id: 'todos', label: 'Todos', dotClassName: 'bg-primary' },
  { id: 'beach-tennis', label: 'Beach Tennis', dotClassName: 'bg-amber-500' },
  { id: 'futevolei', label: 'Futevôlei', dotClassName: 'bg-emerald-500' },
  { id: 'pickleball', label: 'Pickleball', dotClassName: 'bg-blue-500' },
  { id: 'volei-praia', label: 'Vôlei de Praia', dotClassName: 'bg-orange-500' },
];

export type ArenaStatus = 'Aberto agora' | 'Vagas hoje' | 'Torneio ativo';

export interface FeaturedArena {
  id: string;
  status: ArenaStatus;
  rating: number;
  reviewCount: number;
  name: string;
  neighborhood: string;
  address: string;
  sportIds: string[];
  tags: string[];
  priceFrom: number;
  /** Arena recém-cadastrada (sem avaliações ainda): mostra o selo "Nova" no lugar da nota. */
  isNew?: boolean;
}

export interface PlatformStat {
  value: string;
  label: string;
}

export const PLATFORM_STATS: PlatformStat[] = [
  { value: '40+', label: 'arenas parceiras' },
  { value: '12k+', label: 'reservas feitas' },
  { value: '4,8/5', label: 'avaliação média' },
  { value: '0%', label: 'de comprovante perdido' },
];

export interface HowItWorksStep {
  id: string;
  icon: LucideIcon;
  title: string;
  description: string;
}

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    id: 'buscar',
    icon: Search,
    title: 'Encontre a arena',
    description: 'Filtre por esporte, bairro e horário disponível entre as arenas parceiras da sua cidade.',
  },
  {
    id: 'reservar',
    icon: CalendarDays,
    title: 'Reserve o horário',
    description: 'Escolha a quadra e o horário livre. Sua vaga fica garantida na hora, sem ligação nem espera.',
  },
  {
    id: 'dividir',
    icon: Handshake,
    title: 'Divida o Pix com a galera',
    description: 'Convide quem vai jogar e cada um paga sua cota direto pelo app. Chega de cobrar comprovante.',
  },
  {
    id: 'jogar',
    icon: Trophy,
    title: 'É só jogar',
    description: 'Chegou a hora: check-in na arena, aula marcada ou torneio inscrito — tudo num só lugar.',
  },
];

export const FEATURED_ARENAS: FeaturedArena[] = [
  {
    id: 'beira-mar',
    status: 'Aberto agora',
    rating: 4.9,
    reviewCount: 128,
    name: 'Arena Beira Mar Club',
    neighborhood: 'Meireles',
    address: 'Av. Beira Mar, 3200 - Fortaleza',
    sportIds: ['beach-tennis', 'futevolei'],
    tags: ['Beach Tennis', 'Futevôlei', 'Bar & Lazer'],
    priceFrom: 90,
  },
  {
    id: 'aldeota-beach',
    status: 'Vagas hoje',
    rating: 4.8,
    reviewCount: 94,
    name: 'Arena Aldeota Beach',
    neighborhood: 'Aldeota',
    address: 'Rua Desembargador Leite, 890',
    sportIds: ['beach-tennis', 'pickleball'],
    tags: ['Beach Tennis', 'Pickleball'],
    priceFrom: 110,
  },
  {
    id: 'coco-sports',
    status: 'Torneio ativo',
    rating: 5.0,
    reviewCount: 215,
    name: 'Arena Cocó Sports',
    neighborhood: 'Cocó',
    address: 'Av. Engenheiro Santana Jr, 1500',
    sportIds: ['beach-tennis', 'volei-praia'],
    tags: ['Beach Tennis', 'Vôlei de Praia', 'Aulas'],
    priceFrom: 100,
  },
];
